import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import BackButton from '../mobile-menu-item/BackButton';
import MobileMenuItem from '../mobile-menu-item/MobileMenuItem';
import styles from './MobileMenu.scss';

const SubMenu = ({
  open,
  offScreenLeft,
  subMenuData,
  onNavigateBack,
  onItemSelected,
  hierarchy,
}) => {
  const cn = classNames(styles.subMenu, {
    [styles.opened]: open,
    [styles.offScreenLeft]: offScreenLeft,
  });

  return (
    <div className={cn} role="menu">
      <BackButton label={subMenuData.backLabel} onClick={onNavigateBack} />
      <h3 className={styles.mobileMenu__name}>{subMenuData.name}</h3>
      <ul className={styles.mobileMenuList}>
        {subMenuData?.child?.map(menuItem => {
          const { id, name, url, child } = menuItem;
          return (
            <MobileMenuItem
              key={id}
              label={name}
              url={url}
              onClick={() => {
                onItemSelected(menuItem);
              }}
              child={child}
              hierarchy={hierarchy}
            />
          );
        })}
      </ul>
    </div>
  );
};

const itemShape = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
};
itemShape.child = PropTypes.arrayOf(PropTypes.shape(itemShape));

SubMenu.defaultProps = {
  open: false,
  offScreenLeft: false,
  onNavigateBack: undefined,
  onItemSelected: undefined,
  hierarchy: '',
};

SubMenu.propTypes = {
  open: PropTypes.bool,
  offScreenLeft: PropTypes.bool,
  subMenuData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    backLabel: PropTypes.string.isRequired,
    child: PropTypes.arrayOf(PropTypes.shape(itemShape)).isRequired,
  }).isRequired,
  onNavigateBack: PropTypes.func,
  onItemSelected: PropTypes.func,
  hierarchy: PropTypes.string,
};

export default SubMenu;
